import withStyles from '@material-ui/core/styles/withStyles';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import {
  grayColor,
  successColor,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react.jsx';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import Badge from 'components/Badge/Badge.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import TablePagination from 'components/TablePagination/TablePagination.jsx';
import {
  CONFIGURACION_TIPOGRAFIA_14,
  FILA_BLANCA,
  FILA_GRIS,
  LISTADO_PAGINACION,
} from 'config/general/Configuracion';
import AplicarSeguridad from 'conten/components/AplicarSeguridad';
import EncabezadoGrid from 'conten/components/EncabezadoGrid';
import FiltroGeneral from 'conten/components/FiltroGeneral';
import TituloPagina2 from 'conten/components/TituloPagina2';
import WaitDialog from 'conten/components/WaitDialog.jsx';
import {
  guardarPlaca,
  listarPlacas,
  PLACAS_LISTAR,
  PLACAS_LISTAR_SUCCESS,
} from './PlacasActions';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { DirectionsBike } from '@material-ui/icons';

const columnasOrdenar2 = [
  {
    campos: [{ id: '', isSorted: false, label: 'Editar/inhabilitar' }],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },
  {
    campos: [{ id: 'placa', isSorted: true, label: 'Placa' }],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },
  {
    campos: [
      { id: 'tipo_vehiculo', isSorted: true, label: 'Tipo de vehículo' },
    ],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },
  {
    campos: [{ id: 'propietario', isSorted: true, label: 'Propietario' }],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },
  {
    campos: [{ id: 'activo', isSorted: true, label: 'Estado' }],
    xs: 12,
    sm: 12,
    md: 1,
    lg: 1,
  },
  {
    campos: [{ id: 'informacion', isSorted: true, label: 'Información' }],
    xs: 12,
    sm: 12,
    md: 3,
    lg: 3,
  },
];

class PlacaListar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editarPlaca: false,
      placaEditar: undefined,
      textAlertInfo: 'Un momento mientras completamos su solicitud ;)',
      paginacion: {
        limite: LISTADO_PAGINACION[0],
        actual: 1,
        filtro: '',
        orden: 'fh_creacion',
        sentido: 'ASC',
      },
    };
  }

  componentDidMount = () => {
    this.traerDatosServidor();
  };

  traerDatosServidor = () => {
    this.props.listarPlacas(this.state.paginacion);
  };

  cambioPagina = (page) => {
    const paginacionLocal = { ...this.state.paginacion, actual: page };
    this.setState({ paginacion: paginacionLocal }, this.traerDatosServidor);
  };

  cambioLimite = (numFilas) => {
    const paginacionLocal = { ...this.state.paginacion, limite: numFilas };
    this.setState({ paginacion: paginacionLocal }, () => this.cambioPagina(1));
  };

  cambioFiltro = (filtro) => {
    const paginacionLocal = { ...this.state.paginacion, filtro };
    this.setState({ paginacion: paginacionLocal }, () => this.cambioPagina(1));
  };

  ordenar = (_event, property) => {
    const sentido = this.state.paginacion.sentido === 'ASC' ? 'DESC' : 'ASC';
    const paginacionLocal = {
      ...this.state.paginacion,
      orden: property,
      sentido,
    };
    this.setState({ paginacion: paginacionLocal }, () => this.cambioPagina(1));
  };


  editarPlaca = (placaEditar) => {
    this.setState({ placaEditar });
  };

  datosPlacaParaServidor = (placaConsulta) => {
    var placa = {   
      placa: placaConsulta.placa,
      propietario: placaConsulta.propietario,
      creador: placaConsulta.creador,
      informacion: placaConsulta.informacion,
      activo: placaConsulta.activo,
      ultima_modificacion: placaConsulta.ultima_modificacion,
      id: placaConsulta.id
    };
    console.log('datos a enviar:' + placa.propietario)
    return placa;
  };

  resultadoActualizar = (_resultado, _mensaje) => {
    this.traerDatosServidor();
  };
  borrarPlaca = (placa) => {
    var placaActualizar = this.datosPlacaParaServidor(placa);
    placaActualizar.activo = false;
    this.props.guardarPlaca(placaActualizar, this.resultadoActualizar);
  };

  activarPlaca = (placa) => {
    var placaActualizar = this.datosPlacaParaServidor(placa);
    placaActualizar.activo = true;
    this.props.guardarPlaca(placaActualizar, this.resultadoActualizar);
  };

  render() {
    const obtenerIconoVehiculo = (placa) => {
      const regexAuto = /^[A-Z]{3}[0-9]{3}$/; // Formato para carros: ABC123
      const regexMoto1 = /^[A-Z]{3}[0-9]{2}[A-Z]$/; // Formato para motos: ABC12A
      const regexMoto2 = /^[A-Z]{3}[0-9]{2}$/; // Formato alternativo para motos: ABC12

      if (regexAuto.test(placa)) {
        return { icono: <DirectionsCar /> };
      } else if (regexMoto1.test(placa) || regexMoto2.test(placa)) {
        return { icono: <DirectionsBike /> };
      }
      return { tipo: 'Desconocido', icono: null };
    };

    const { classes, placaState } = this.props;

    const { placas = [], paginacion = {}, isActivityIndicatorShown = false } =
      placaState || {};

    if (this.state.placaEditar) {
      return (
        <Redirect
          push
          to={{
            pathname: '../admin/administrar-placas',
            search: '?editar=true',
            state: {
              placa: this.datosPlacaParaServidor(this.state.placaEditar),
            },
          }}
        />
      );
    }

    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textAlertInfo} />
        )}
        <AplicarSeguridad />
        <Card>
          <CardHeader icon>
            <CardIcon
              color='primary'
              style={{ cursor: 'pointer' }}
              onClick={() =>
                this.props.history.push('../admin/administrar-placas')
              }
            >
              <b>{'Nueva placa'}</b>
              <DirectionsCar />
            </CardIcon>
            <TituloPagina2
              texto='Listado de placas'
              color='primary'
              classes={classes}
            />
          </CardHeader>

          <CardBody>
            <EncabezadoGrid
              contenidoColumnas={columnasOrdenar2}
              eventoOrdenar={this.ordenar}
              ordenarPor={paginacion.orden}
              sentidoOrden={paginacion.sentido}
              colorFondo={successColor[0]}
              colorTexto={whiteColor}
              tamaLetra='14px'
            />

            <FiltroGeneral
              keyFiltro='FiltroPlacas'
              colorTexto={whiteColor}
              colorFondo={grayColor[21]}
              eventoFiltrar={this.cambioFiltro}
              tamaLetra='14px'
              texto='Buscar'
              state={this}
            />

            {placas.map((placa, index) => {
              const { icono } = obtenerIconoVehiculo(placa.placa);
              return (
                <GridContainer
                  key={placa.id || index}
                  container
                  alignItems='center'
                >
                  <GridItem xs={12} sm={12} md={2} lg={2}>
                    <Button
                      color={placa.activo ? 'green' : 'danger'}
                      simple
                      onClick={() => this.editarPlaca(placa)}
                    >
                      <Edit />
                    </Button>
                    {placa.activo ? (
                      <Button
                        color='green'
                        simple
                        onClick={() => this.borrarPlaca(placa)}
                      >
                        <DeleteIcon />
                      </Button>
                    ) : (
                      <Button
                        color='danger'
                        simple
                        onClick={() => this.activarPlaca(placa)}
                      >
                        <RestoreFromTrashIcon />
                      </Button>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={2} lg={2}>
                    {placa.placa}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2} lg={2}>
                    {icono}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2} lg={2}>
                    {placa.propietario}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={1} lg={1}>
                    <Badge color={placa.activo ? 'greenColor' : 'danger'}>
                      {placa.activo ? 'Activo' : 'Inactivo'}
                    </Badge>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3} lg={3}>
                    {placa.informacion}
                  </GridItem>
                </GridContainer>
              );
            })}

            {paginacion && (
              <TablePagination
                color='success'
                rowsPerPageOptions={LISTADO_PAGINACION}
                pages={Math.ceil(paginacion.total / paginacion.limite)}
                rowsPerPage={paginacion.limite}
                page={paginacion.actual}
                onChangePage={this.cambioPagina}
                onChangeRowsPerPage={this.cambioLimite}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    placaState: state.placaState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    listarPlacas: (paginacion) => dispatch(listarPlacas(paginacion, () => {})),
    guardarPlaca: (placa, onSuccess) =>
      dispatch(guardarPlaca(placa, onSuccess)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlacaListar)
);
